export default "__VITE_ASSET__C7bP5TQE__"